import React, { DetailedHTMLProps, TextareaHTMLAttributes } from 'react';
import classNames from 'classnames';
import { countCharactersExcludeNewlines, sliceString } from '../../../lib/utils/countCharacters';
import './TextAreaField.scss';

export type TextAreaSize = 'medium' | 'large';

export type TextAreaProps = {
  id: string;
  label: string;
  size?: TextAreaSize;
  className?: string;
  value?: string;
  readonly?: boolean;
  limit?: number;
  hasError?: boolean;
} & Omit<DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>, 'ref'>;

const sizeMap: { [key in TextAreaSize]: string } = {
  medium: 'p-3 text-base',
  large: 'p-4 text-base',
};

const TextAreaField = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    { id, label, size = 'medium', className = '', placeholder, value, readonly, hasError, onChange, limit, ...props },
    ref,
  ) => {
    return (
      <div className="textAreaField-wrap">
        <textarea
          id={id}
          ref={ref}
          value={value}
          aria-label={label}
          placeholder={placeholder}
          className={classNames([sizeMap[size], className, { 'error-border': hasError }])} // Add hasError class conditionally
          readOnly={readonly}
          onChange={(e) => {
            if (!limit || (limit && countCharactersExcludeNewlines(e.target.value) <= limit)) {
              if (onChange) onChange(e);
            } else {
              e.target.value = sliceString(e.target.value, 0, limit);
              if (onChange) onChange(e);
            }
          }}
          {...props}
        />
      </div>
    );
  },
);

TextAreaField.displayName = 'TextAreaField';

export default TextAreaField;
